export default __webpack_public_path__ + "static/media/gnp-logo.cec7ab03.png";